import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Stack, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, ICONS, unit } from '@hcr/ui'

interface TicketsInfoProps {
  cta?: ReactNode
  title?: ReactNode
  totalTickets: number
}

export const TicketsInfo: FC<TicketsInfoProps> = ({ cta, totalTickets, title }) => {
  const { t } = useTranslation()

  return (
    <Stack alignItems='center' gap={unit(3)}>
      {title}

      <Typography variant='bodyS' fontWeight='initial' color={COLORS.white} sx={{ whiteSpace: 'nowrap' }}>
        <FontAwesomeIcon color={COLORS.white} icon={ICONS.farLayerGroup} style={{ marginRight: unit(1) }} />
        {totalTickets > 1
          ? t('utils.tickets-count-plural', { count: totalTickets })
          : t('utils.tickets-count', { count: totalTickets })}
      </Typography>

      {cta}
    </Stack>
  )
}
